export const chartColumns = [
  {
    field: 'serviceName',
    title: '服务名称',
    width: '120',
  },
  {
    field: 'expenseName',
    title: '费用类型',
    width: '150',
  },
  {
    field: 'routeName',
    title: '线路名',
    width: '150',
  },
  {
    field: 'departurePlaceName',
    title: '启运地',
    width: '150',
  },
  {
    field: 'destinationName',
    title: '目的地',
    width: '150',
  },
  //fixme
  {
    field: 'productParentName',
    title: '商品名称',
    width: '150',
  },
  //fixme
  {
    field: 'productDetailCode',
    title: '商品子类简码',
    width: '150',
  },
  {
    field: 'detailProductItems',
    title: '品目',
    width: '140',
  },
  {
    field: 'detailProductModel',
    title: '规格',
    width: '140',
  },
  {
    field: 'cubeType',
    title: '箱型',
    width: '140',
  },
  {
    field: 'cubeTypeName',
    title: '箱型名字',
    width: '140',
    visible: false,
  },
  // {
  //   field: 'qty',
  //   title: '数量',
  //   width: '150',
  // },
  // //fixme
  // {
  //   field: 'qtyUnit',
  //   title: '数量单位',
  //   width: '150',
  // },
  //fixme
  {
    field: 'chargeUnit',
    title: '计费单位',
    width: '150',
  },
  {
    field: 'supplierInquiry',
    title: '供方报价',
    width: '150',
  },
  {
    field: 'customerInitialQuotation',
    title: '客户初次报价',
    width: '150',
  },
  {
    field: 'customerFinalQuotation',
    title: '客户最终报价',
    width: '150',
  },
  {
    field: 'remarks',
    title: '备注',
    width: '150',
  },
];

export const quotationRuleColumns = [
  {
    field: 'serviceName',
    title: '服务名称',
    width: '120',
  },
  {
    field: 'expenseName',
    title: '费用类型',
    width: '150',
  },
  {
    field: 'routeName',
    title: '线路名',
    width: '150',
  },
  {
    field: 'departurePlaceName',
    title: '启运地',
    width: '150',
  },
  {
    field: 'destinationName',
    title: '目的地',
    width: '150',
  },
  //fixme
  {
    field: 'productParentName',
    title: '商品名称',
    width: '150',
  },
  //fixme
  {
    field: 'productDetailCode',
    title: '商品子类简码',
    width: '150',
  },
  {
    field: 'detailProductItems',
    title: '品目',
    width: '140',
  },
  {
    field: 'detailProductModel',
    title: '规格',
    width: '140',
  },
  {
    field: 'cubeType',
    title: '箱型',
    width: '140',
  },
  {
    field: 'cubeTypeName',
    title: '箱型名字',
    width: '140',
    visible: false,
  },
  //fixme
  {
    field: 'chargeUnit',
    title: '计费单位',
    width: '150',
  },
  {
    field: 'unitPriceWithTax',
    title: '计费含税单价',
    width: '150',
  },
  {
    field: 'remarks',
    title: '备注',
    width: '150',
  },
];

export const checkZero = (rule, value, callback) => {
  if (!value) {
    return callback(new Error('不能为空'));
  }
  if (value == 0) {
    callback(new Error('请输入大于0的数值'));
  } else {
    callback();
  }
};
